import React, { useState, useEffect } from 'react';
import '../../src/css/modal.css';
function Modal() {
  const [isOpen, setIsOpen] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const slides = [
    {
      image: "https://iwebapps.noidapower.com:8032/PopUp/CLPBanner.png",
      link: "https://webapps.noidapower.com:9191/webp/r/npcl/sign-in-portal/existing-user-sign-in?CLP=Y",
      alt: "Banner"
    },
    {
      image: "https://iwebapps.noidapower.com:8032/PopUp/RoofTopBanner.png",
      link: "https://www.noidapower.com/roof-top-solar-calculations",
      alt: "Banner"
    },
    {
      image: "https://iwebapps.noidapower.com:8032/PopUp/bannerp2p2.jpeg",
      link: "https://webapps.noidapower.com:9191/webp/r/npcl/sign-in-portal/existing-user-sign-in",
      alt: "Banner"
    },
    {
      image: "https://iwebapps.noidapower.com:8032/PopUp/img1.jpg",
      link: "https://pmsuryaghar.gov.in/consumerLogin",
      alt: "Surya Ghar"
    },
    {
      image: "https://iwebapps.noidapower.com:8032/PopUp/img4.jpg",
      link: "https://eeslmart.in/?affiliateid=npcl",
      alt: "EESL"
    }
  ];
  const closeModal = () => {
    setIsOpen(false);
  };
  const nextSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev + 1) % slides.length);
    setTimeout(() => setIsTransitioning(false), 600);
  };
  const prevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    setTimeout(() => setIsTransitioning(false), 600);
  };
  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, []);
  if (!isOpen) return null;
  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-container" onClick={e => e.stopPropagation()}>
        <button className="close-button" onClick={closeModal}>×</button>
        <div className="slider-container">
          <div className="slides-track" style={{
            transform: `translateX(-${currentSlide * 100}%)`,
          }}>
            {slides.map((slide, index) => (
              <div key={index} className="slide">
                <a
                  href={slide.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="slide-link"
                >
                  <img
                    src={slide.image}
                    alt={slide.alt}
                    className="slide-image"
                  />
                </a>
              </div>
            ))}
          </div>
         
          <button className="nav-button prev" onClick={prevSlide}>❮</button>
          <button className="nav-button next" onClick={nextSlide}>❯</button>
         
          <div className="dots">
            {slides.map((_, index) => (
              <span
                key={index}
                className={`dot ${currentSlide === index ? 'active' : ''}`}
                onClick={() => {
                  if (isTransitioning) return;
                  setIsTransitioning(true);
                  setCurrentSlide(index);
                  setTimeout(() => setIsTransitioning(false), 600);
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
export default Modal;
